import React, { useEffect, useState } from 'react';
import moment from 'moment';
import './style.css';
import { getFile } from '@opu/utils';
import { useTranslation } from 'react-i18next';

const Text = ({ text, type = null, id = null, role = null, maxLength = 20 }) => {
  const { t, i18n } = useTranslation();

  const [value, setValue] = useState(null);
  useEffect(() => {
    if (type === 'switcherContract') {
      if (text === 'ENABLED') setValue(true);
      else setValue(false);
    } else setValue(text);
  }, []);

  if (Array.isArray(text)) {
    if (type === 'contract_status') {
      if (text.length > 0 && text[0] === 'ENABLED') return <span className="badge badge-success">{t('ENABLED')}</span>;
      else return <span className="badge badge-warning">{t('DISABLE')}</span>;
    }
    return text.slice(0, 3).map((txt) => <span className="badge badge-secondary">{txt}</span>);
  } else {
    if (text !== '') {
      if (type === 'date') {
        text = new Date(text);
        text = moment(text).format('DD/MM/YYYY');
      } else if (type === 'time') {
        text = new Date('January 1, ' + text);
        text = moment(text).format('HH:mm');
      } else if (type === 'dateTime') {
        text = new Date(text);
        text = moment(text).format('DD/MM/YYYY HH:mm');
      } else if (type === 'actionLog') {
        text = t(`action-log.action.${text}`);
      } else if (type === 'actionLogMessage') {
        const split = text.split('<<SEPARATOR>>');
        return (
          <div>
            <span>{t(`action-log.action.${split[0].trim()}`)}</span> <b className="font-weight-bold">{split[1].trim()}</b>
          </div>
        );
      } else if (type === 'duree') {
        text = new Date('January 1, ' + text);
        text = moment(text).format('HH:mm');
        text = text.replace(':', 'H') + 'min';
      } else if (type === 'image') {
        return <img src={getFile('book', text)} alt="cover" style={{ width: 50, height: 30 }} />;
      } else if (type === 'rating') {
        text = text % 2 !== 0 ? text.toFixed(1) : text;
      } else if (type === 'author_display') {
        if (text) return <span className="badge badge-success">{t('author.show')}</span>;
        else return <span className="badge badge-warning">{t('author.hide')}</span>;
      }
    } else text = '-';

    if (typeof text === 'string' && !['date', 'time', 'dateTime', 'rating'].includes(type)) {
      return (
        <span className="limited-text" data-bs-toggle="tooltip" data-bs-placement="top" title={text}>
          {text}
        </span>
      );
    }
    return <span>{text}</span>;
  }
};

export default Text;
